import Vue from 'vue';
import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { PremiumGroupSeatRedemption } from 'frontend/types/premium/group-plans';

const premiumGroupSeatRedeem: Module<PremiumGroupSeatRedemption, RootState> = {
  namespaced: true,
  state: {} as PremiumGroupSeatRedemption,
  mutations: {
    setValue(state: PremiumGroupSeatRedemption, value: PremiumGroupSeatRedemption) {
      Object.assign(state, value);
    },
  },
};

export default premiumGroupSeatRedeem;
